import SlideComponent from "../elements/SlideComponent";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Mobile() {
  const slides = [
    {
      stepTxt: "Step 1",
      info: "Sign Up and Subscribe",
      image: "/slide1.png",
      description: [
        "Easily create an account.",
        "Securely pay $12 per year through our encrypted gateway.",
        "Instantly access the full range of Testament.Digital features.",
      ],
    },
    {
      stepTxt: "Step 2",
      info: "Upload and Organize Files",
      image: "/slider2.png",
      description: [
        "Effortlessly upload and manage your important files.",
        "Organize your digital assets with our intuitive system.",
        "Rest easy knowing your files are securely stored for future sharing.",
      ],
    },
    {
      stepTxt: "Step 3",
      info: "Craft Your Messages",
      image: "/slider3.png",
      description: [
        "Access our user-friendly message creation interface.",
        "Create heartfelt messages and attach personal files.",
        "Edit messages anytime to ensure they reflect your intentions.",
      ],
    },
  ];

  const settings = {
    autoplay: false,
    dots: true,
    className: "center",
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="mobXS:container mx-auto">
      <div className="desktop:hidden ">
        <h4 className="text-h4 text-dark3 text-center py-8 justify-center">
          How it works
        </h4>
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <SlideComponent key={index} {...slide} />
          ))}
        </Slider>
      </div>
    </div>
  );
}
